import Grid2 from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useUserContext } from "@dexteel/mesf-core";
import { CraftsFilter } from "./craftsFilter";
import { EndFilter } from "./endFilter";
import { useSearchParamsToReducer } from "./hooks/useSearchParamsToReducer";
import { SearchFilter } from "./SearchFilter";
import { StartFilter } from "./startFilter";
import { StatusFilter } from "./statusFilter";
import { TypesFilter } from "./typesFilter";
import { useWorkOrdersContext } from "../context/workOrdersContext";

export const Filters = () => {
	useSearchParamsToReducer();
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const {
		state: { defaultAreaId },
	} = useUserContext();
	const {
		state: {
			dataToGetWorkOrders: { ShowDownDay },
		},
		actions: { setFirstTime, setShowDownDayWorkOrders },
	} = useWorkOrdersContext();

	const resetFilter = () => {
		setShowDownDayWorkOrders(false);
		setFirstTime(true);
		setSearchParams(new URLSearchParams(), { replace: true });
		setTimeout(() => {
			navigate(`/work-orders/${defaultAreaId}`, { replace: true });
		}, 50);
	};

	return (
		<Grid2 container alignItems="flex-end" spacing={1}>
			<Grid2 size={{ lg: 1.5, md: 6, xs: 12 }}>
				<StartFilter />
			</Grid2>
			<Grid2 size={{ lg: 1.5, md: 6, xs: 12 }}>
				<EndFilter />
			</Grid2>
			<Grid2 size={{ lg: 2.5, md: 6, xs: 12 }}>
				<SearchFilter />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<StatusFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<CraftsFilter />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<TypesFilter />
			</Grid2>
			<Grid2 size={{ lg: 1.5, md: 6, xs: 12 }}>
				<Box
					sx={{
						marginTop: "8px",
						marginBottom: "4px",
						height: "40px",
						display: "flex",
						alignItems: "center",
					}}
				>
					<Tooltip title="Show only work orders flagged as down day">
						<FormControlLabel
							control={
								<Checkbox
									checked={!!ShowDownDay}
									onChange={(e) =>
										setShowDownDayWorkOrders(e.target.checked)
									}
									color="primary"
								/>
							}
							label="Down day"
						/>
					</Tooltip>
				</Box>
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<Box sx={{ marginTop: "8px", marginBottom: "4px" }}>
					<Button
						fullWidth
						variant="contained"
						color="inherit"
						onClick={resetFilter}
						sx={{ height: "40px" }}
					>
						RESET
					</Button>
				</Box>
			</Grid2>
		</Grid2>
	);
};
